"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPlasticsPartSchema = void 0;
const zod_1 = require("zod");
const InputJsonValue_1 = require("../inputTypeSchemas/InputJsonValue");
const DataSourceSchema_1 = require("../inputTypeSchemas/DataSourceSchema");
const ArticleSpecSchema_1 = require("../inputTypeSchemas/ArticleSpecSchema");
const ArticleTypeSchema_1 = require("../inputTypeSchemas/ArticleTypeSchema");
const WeightUnitSchema_1 = require("../inputTypeSchemas/WeightUnitSchema");
const SmartPlasticsTypeSchema_1 = require("../inputTypeSchemas/SmartPlasticsTypeSchema");
/////////////////////////////////////////
// SMART PLASTICS PART SCHEMA
/////////////////////////////////////////
exports.SmartPlasticsPartSchema = zod_1.z.object({
    dataSource: DataSourceSchema_1.DataSourceSchema,
    articleSpecs: ArticleSpecSchema_1.ArticleSpecSchema.array(),
    articleType: ArticleTypeSchema_1.ArticleTypeSchema,
    weightUnit: WeightUnitSchema_1.WeightUnitSchema,
    smartPlasticsType: SmartPlasticsTypeSchema_1.SmartPlasticsTypeSchema.array(),
    akeneoSku: zod_1.z.string(),
    akeneoUuid: zod_1.z.string().nullish(),
    discontinuedModel: zod_1.z.boolean(),
    echainId: zod_1.z.string(),
    artNr: InputJsonValue_1.InputJsonValue,
    description: InputJsonValue_1.InputJsonValue,
    weight: zod_1.z.number(),
    smartPlasticsCableId: zod_1.z.string().nullish(),
    smartPlasticsParentEchainId: zod_1.z.string().nullish(),
    partsReferences: InputJsonValue_1.InputJsonValue.array(),
    ecfAllowed: zod_1.z.boolean(),
    eicAllowed: zod_1.z.boolean(),
    eiqAllowed: zod_1.z.boolean(),
    ekeAllowed: zod_1.z.boolean(),
});
exports.default = exports.SmartPlasticsPartSchema;
//# sourceMappingURL=SmartPlasticsPartSchema.js.map